var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasBookmarks
    ? _c("expandable-panel", {
        staticClass: "notes-expansion-panel-wrapper border",
        attrs: {
          expand: _vm.expand,
          id: `notes-expansion-panel-wrapper-${_vm.sectionId}`,
          outlined: "",
        },
        on: { changeExpansion: _vm.changeExpansion },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticStyle: { display: "inline" } },
                    [
                      _c(
                        "span",
                        { staticClass: "text--secondary font-weight-bold" },
                        [
                          _vm._v(
                            "\n                NOTES (" +
                              _vm._s(_vm.bookmarksCount) +
                              ")\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.displaySortButton
                        ? [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "no-print",
                                                  staticStyle: {
                                                    float: "right",
                                                  },
                                                  attrs: {
                                                    small: "",
                                                    depressed: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.toggleSortOrder.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { small: "" },
                                                },
                                                [_vm._v("mdi-sort-variant")]
                                              ),
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.sortOrder === "desc"
                                                      ? "Newest First"
                                                      : "Oldest First"
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3681367901
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("span", { staticClass: "tooltip-content" }, [
                                  _vm._v("Reverse sort direction"),
                                ]),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _vm.showAllBtn && _vm.sortOrder === "asc"
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mb-2 no-print",
                          attrs: { depressed: "", small: "", block: "" },
                          on: { click: _vm.showAllBookmarks },
                        },
                        [
                          _vm._v(
                            "\n            Show All (" +
                              _vm._s(_vm.bookmarksCount) +
                              ")\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.sortedBookmarks, function (item) {
                    return _c(
                      "v-card",
                      {
                        key: item.id,
                        attrs: {
                          id: "bookmark-list-item-" + item.id,
                          flat: "",
                        },
                      },
                      [
                        _c(
                          "v-card-text",
                          { staticClass: "pa-0 notes-bookmarks-section" },
                          [
                            _c("note-list-item", {
                              attrs: {
                                showNoteControlMenu: _vm.showNoteControlMenu,
                                type: _vm.bookmarkType(item),
                                data: item,
                                tags: _vm.tags,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.showAllBtn && _vm.sortOrder === "desc"
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "no-print",
                          attrs: { depressed: "", small: "", block: "" },
                          on: { click: _vm.showAllBookmarks },
                        },
                        [
                          _vm._v(
                            "\n            Show All (" +
                              _vm._s(_vm.bookmarksCount) +
                              ")\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          353129190
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }